import React, { type HTMLAttributes } from 'react';

import { type CSSProp } from 'styled-components';

import { FlexWrapper } from './styles';

interface WrapperProps extends HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
    direction?: 'row' | 'column';
    justifyContent?: CSSProp;
    flexWrap?: CSSProp;
    alignItems?: CSSProp;
    margin?: CSSProp;
    gap?: CSSProp;
    padding?: CSSProp;
    width?: CSSProp;
    height?: CSSProp;
}

export const Wrapper = ({
    children,
    direction = 'column',
    alignItems,
    flexWrap,
    gap,
    justifyContent,
    margin,
    padding,
    width,
    height,
    ...rest
}: WrapperProps) => {
    return (
        <FlexWrapper
            $alignItems={alignItems}
            $gap={gap}
            $justifyContent={justifyContent}
            $flexDirection={direction}
            $flexWrap={flexWrap}
            $padding={padding}
            $margin={margin}
            $width={width}
            $height={height}
            {...rest}
        >
            {children}
        </FlexWrapper>
    );
};
